import cookie from 'js-cookie';
// 合同管理
const Contract = () => import('@/pages/compact/compact-list.vue');
const moneyBack = () => import('@/pages/compact/moneyback-list.vue');
const Cost = () => import('@/pages/compact/cost-list.vue');
const Spend = () => import('@/pages/compact/spend-list.vue');
const ContractInside = () => import('@/pages/compact-inside');
const envCrm = cookie.get("_env_crm__") !== "false";

const arr = [
  // 合同管理
  {
    path: '/compact/contract',
    name: 'contract',
    component: envCrm ? ContractInside : Contract,
    meta: {
      auth: false,
    },
  },
  // 回款列表
  {
    path: '/compact/moneyback',
    name: 'moneyback',
    component: moneyBack,
    meta: {
      auth: false,
    },
  },
  // 成本列表
  {
    path: '/compact/cost',
    name: 'cost',
    component: Cost,
    meta: {
      auth: false,
    },
  },
  // 支出合同列表
  {
    path: '/compact/spend',
    name: 'spend',
    component: Spend,
    meta: {
      auth: false,
    },
  },
];

export default arr;
